<template>
    <div :class="'media-container-' + type" :style="containerStyle" class="media-container">
        <span :class="(xl ? 'media-text-xl' : '')" class="media-text" v-if="type === 'text'">{{ textSource }}</span>
        <span :class="(xl ? 'media-mixed-xl' : '')" class="media-mixed" v-html="mixedSource"
              v-if="type === 'mixed'"></span>
        <img :src="imageSource" class="media-image" v-if="type === 'image'"/>
        <iframe
                :src="frameSource"
                allowfullscreen
                class="media-frame"
                frameborder="0"
                mozallowfullscreen
                v-if="type === 'frame'"
                webkitallowfullscreen
        ></iframe>
    </div>
</template>
<script>
    import * as RegexYouTube from 'youtube-regex'
    import * as RegexVimeo from 'vimeo-regex'
    import * as EmojiRegex from 'emoji-regex'
    import {MediaUtil} from '@/utils/MediaUtil'
    import {TextUtil} from '@/utils/TextUtil'
    import emojiTranslationTable from '@/asset-manager/emoji-translation-table';

    export default {
        name: 'media',
        props: {
            source: {
                type: String,
                required: true
            },
            width: {
                default: 640
            },
            height: {
                default: 360
            }
        },
        data() {
            // The RegExp call makes sure that we remove the global param from the regex meaning
            // we'll be able continuously call "exec" without getting NULL half the time

            const regexYoutube = RegExp(RegexYouTube())
            const regexVimeo = RegexVimeo()
            const emojiRegex = EmojiRegex();

            return {
                regexYoutube: regexYoutube,
                regexVimeo: regexVimeo,
                emojiRegex: emojiRegex
            }
        },
        methods: {
            matchRegex(regex, source) {
                regex.lastIndex = 0

                return regex.exec(source)
            }
        },
        computed: {
            containerStyle() {
                let width = this.width;
                let height = this.height;

                if (typeof (width) === 'number') {
                    width = width + 'px';
                }

                if (typeof (height) === 'number') {
                    height = height + 'px';
                }

                return {
                    width: width,
                    height: height
                };
            },
            xl() {
                let sourceWithoutEmojis = this.source.replace(this.emojiRegex, '');
                ;
                // The text only has emojis - let's make them large
                return sourceWithoutEmojis === '';
            },
            type() {
                if (this.source.match(/^https?\:\/\//)) {
                    // It's an url
                    return 'frame';
                } else if (this.source.match(/\.(png|jpg|gif)$/)) {
                    return 'image';
                } else if (emojiTranslationTable.hasOwnProperty(this.source)) {
                    return 'image';
                } else if (this.source.match(this.emojiRegex)) {
                    return 'mixed';
                } else {
                    return 'text';
                }
            },
            textSource() {
                return this.source;
            },
            mixedSource() {
                return TextUtil.replaceEmojisInText(this.source);
            },
            imageSource() {
                let source = this.source;

                if (emojiTranslationTable.hasOwnProperty(source)) {
                    source = emojiTranslationTable[source].large;
                }

                return MediaUtil.getMediaUrl(source);
            },
            frameSource() {
                if (this.regexVimeo.test(this.source)) {
                    let executionResult = this.matchRegex(this.regexVimeo, this.source)
                    let vimeoId = executionResult[5] || executionResult[4]

                    return 'https://player.vimeo.com/video/' + vimeoId
                } else if (this.regexYoutube.test(this.source)) {
                    let executionResult = this.matchRegex(this.regexYoutube, this.source)

                    let youtubeId = executionResult[1]

                    return 'https://www.youtube.com/embed/' + youtubeId
                } else {
                    // Just output the raw source
                    return this.source;
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "~@less/font-sizes.less";

    .media-container {
        text-align: center;
        margin: 0 auto 15px auto;
        max-width: 100%;
    }

    .media-frame {
        width: 100%;
        height: 100%;
        margin: 0 auto;
    }

    .media-text.media-text-xl,
    .media-mixed.media-mixed-xl {
        font-size: @app-font-size-emoji-xl;
    }

    .media-image {
        max-width: 100%;
        max-height: 100%;
    }
</style>